import { Flex } from 'antd'
import { useTheme } from 'antd-style'

import { Text, Title } from 'src/components'

type Props = {
  title: string
  description?: string
}

export const AuthHeader = ({ title, description = '' }: Props) => {
  const palette = useTheme()

  return (
    <Flex vertical>
      <Title weight={700} level={4}>
        {title}
      </Title>

      <Text color={palette.black.black1}>{description}</Text>
    </Flex>
  )
}
